import Swiper, {Pagination, Navigation, Autoplay} from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);

export namespace iconLinksSlider {

	let setupSlider = () => {
		let iconLinksSliders = document.querySelectorAll('.js-icon-links');

		iconLinksSliders.forEach((slider, index) => {
			slider.classList.add(`icon-links__swiper--${index}`);
			const swiper = new Swiper(`.icon-links__swiper--${index}`, {
				spaceBetween: 0,
				initialSlide: 0,
				breakpoints: {
					0: {
						slidesPerView: 1,
						spaceBetween: 0,
						initialSlide: 0
					},
					768: {
						slidesPerView: 3,
						spaceBetween: 20,
						initialSlide: 1,
					}
				},

				navigation: {
					nextEl: `.swiper-button-next`,
					prevEl: `.swiper-button-prev`,
				}
			});
		});
	}

	export const init = () => {
		setupSlider();
	}
}

document.addEventListener('DOMContentLoaded', iconLinksSlider.init);
